import { TempBreadCrumbsDTO } from '../../Library/types';
import { ResponseError } from '../api/config';
import { TagType } from '../store/tags.store';
// import { TagType } from '../components/Tags/types';

export enum View {
  All = 'All',
  Files = 'Files',
  Trash = 'Trash',
}
export enum StatusFilterEnum {
  Active = 'Open',
  New = 'New',
  Closed = 'Closed',
  Unread = 'Unread',
}

export enum InboxEntryStatus {
  Open = 'Open',
  New = 'New',
  Closed = 'Closed',
}

export enum InboxEntrySource {
  WebApp = 'WebApp',
  Email = 'Email',
}

export enum InboxEntryType {
  THREAD = 'THREAD',
  DOCUMENT = 'DOCUMENT',
}

export enum EmailEntryType {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
}

export enum ReplyType {
  REPLY = 'Reply',
  REPLY_ALL = 'Reply All',
}

export enum FILE_TASK_LINK_KEY {
  INBOX_EMAIL_ATTACHMENT_ID = 'inbox-email-attachment-id',
  INBOX_DOCUMENT_ID = 'inbox-document-id',
}

export const ACTIVE_EMAIL_STATUSES = [
  InboxEntryStatus.Open,
  InboxEntryStatus.New,
];

export type InboxEntryFile = {
  id: number;
  name: string;
  isFileSupported?: boolean;
  cid?: string;
  isFromMessaging?: boolean;
};

export type EmailThreadEntryFiles = {
  list: InboxEntryFile[];
  count: number;
};

// TODO: update prop "BY" user props from any to actual type
type User = {
  id: number;
  firstName: string;
  lastName: string;
};

export type UserWithFullName = {
  id: number;
  fullName: string;
};

export type UserWithFullNameAndEmail = {
  id?: number;
  fullName: string;
  emailAddress: string;
};

export type UserWithFullNameAndEmailAndAvatar = UserWithFullNameAndEmail & {
  avatar: string;
};

export type UserWithAvatar = User & {
  avatar: string;
};

export type SidebarInboxEntryCommonProps = {
  id: number;
  source: InboxEntryType;
  subject: string;
  from: string[];
  status: InboxEntryStatus;
  createdDate: string;
  isRead: boolean;
  isDeleted: boolean;
  isAccountRead: boolean;
};

export type SidebarEmailThreadEntry = SidebarInboxEntryCommonProps & {
  text: string;
  files: EmailThreadEntryFiles;
  openInboundEmailsCount: number;
  openInboundAttachmentsCount: number;
  emailEntriesCount: number;
  isAllEntriesOutbound: boolean;
  // senders: string[];
};

export type SidebarFileEntry = SidebarInboxEntryCommonProps & {
  googleDriveFileUrl?: string;
  file: {
    id: number;
    name: string;
    isFileSupported: boolean;
    isFromMessaging?: boolean;
  };
};

export type InboxEntryCommonProps = {
  id: number;
  source: string;
  from: UserWithFullNameAndEmail;
  status: InboxEntryStatus;
  createdDate: string;
  openedDate: string;
  openedBy: string;
  closedDate: string;
  closedBy: string;
  modifiedDate: string;
  modifiedBy: string;
  isRead: boolean;
  isMisc: boolean;
  // isStarred: boolean;
  workstreams: any[];
  tasks: any[];
  taskList?: any[];
  accessList: any[];
  isMultiPagePdf: boolean;
};

// export type EmailThreadEntry = InboxEntryCommonProps & {
//   raw: string;
//   files: EmailThreadEntryFiles;
//   openInboundEmailsCount: number;
//   openInboundAttachmentsCount: number;
//   emailEntriesCount: number;
//   senders: string[];
//   emailAddress: string;
//   threadId: number;
// };

type InboxEntryPermissions = {
  trash: boolean;
  deletePermanent: boolean;
  misc: boolean;
  tagWorkstream: boolean;
  restore: boolean;
  changeStatus: boolean;
  createTask: boolean;
  read: boolean;
};

export enum CloseReasonCode {
  ATTACHMENTS_NOT_CLOSED = 'ATTACHMENTS_NOT_CLOSED',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  NOT_OPENED = 'NOT_OPENED',
  CLOSED = 'CLOSED',
}

export type InboxEntryAlowClose = {
  allowed: boolean;
  reasonCode?: CloseReasonCode;
};

export type FileEntryPermission = InboxEntryPermissions & {
  record: boolean;
  rename: boolean;
  duplicate: boolean;
  archive: boolean;
  copyFileUrl: boolean;
  download: boolean;
  createTransaction: boolean;
};

export type EmailEntryPermission = InboxEntryPermissions & {
  print: boolean;
  copyEmailUrl: boolean;
  info: boolean;
  createReply: boolean;
};

// library-location
type LibraryLocation = {
  id: number;
  path: string; // library-id
  tempBreadCrumbs?: TempBreadCrumbsDTO;
};

export type FileEntry = InboxEntryCommonProps & {
  file: {
    id: number;
    name: string;
    rawName: string;
    folder?: {
      id: number;
      location: string;
    };
    user: User;
    googleDriveFileUrl?: string;
    isFileSupported?: boolean;
    libraryLocation?: LibraryLocation;
  };
  tags: TagType[];
  fileSize: string;
  fileLocation: string;
  isRecorded: boolean;
  recordedBy: string;
  recordedDate: string;
  isArchivedInLibrary: boolean;
  isDeleted?: boolean;
  duplicate: boolean;
  allowedStatusChanges: InboxEntryStatus[];
  allowClose: InboxEntryAlowClose;
  permissions: FileEntryPermission;
  shouldWaitSocketUpdate?: boolean;
};

export type SidebarInboxEntryData = SidebarEmailThreadEntry | SidebarFileEntry;

export type RawInboxEntry = {
  date: string;
  from: string[];
  read: boolean;
  source: InboxEntryType;
  'source-id': number;
  status: InboxEntryStatus;
  subject: string;
  document?: {
    id: number;
    name: string;
    status: InboxEntryStatus;
    'uploaded-by': string;
    conversation: boolean;
  };
  thread?: {
    'total-attachments-count': number;
    'total-emails-count': number;
    'open-inbound-attachments-count': number;
    'open-inbound-emails-count': number;
    'all-outbound': boolean;
    'all-outbound-attachments-count': number;
    attachments: any[];
    text: string;
  };
  trash: boolean;
  'permanently-deleted': boolean;
  accountRead: boolean;
  'account-read': boolean;
};

export type InboxEntry = {
  data: SidebarInboxEntryData;
  type: InboxEntryType;
};

export type FilterCounters = {
  new: number;
  open: number;
};

export type FileEntryToUpdateStatus = InboxEntryFile & {
  id: number;
  status: InboxEntryStatus;
  isRead: boolean;
  // isMisc: boolean;
  // isRecorded: boolean;
  // isArchivedInLibrary: boolean;
  // tasks: any[];
  user?: {
    fullName: string;
  };
  // userId: number;
  allowedStatusChanges: InboxEntryStatus[];
  allowClose: InboxEntryAlowClose;
  duplicate: boolean;
  // isCurrentUserAuthorized: boolean;
};

export type EmailEntryFiles = {
  list: EmailFileEntry[];
  total: number;
};

export type EmailEntryListItem = {
  id: number;
  from: UserWithFullNameAndEmailAndAvatar[];
  cc: UserWithFullNameAndEmailAndAvatar[];
  to: UserWithFullNameAndEmailAndAvatar[];
  html: string;
  text: string;
  subject: string;
  dateAdded: string;
  emailType: EmailEntryType;
  files: EmailEntryFiles;
  status: InboxEntryStatus;
  isRead: boolean;
  isDeleted: boolean;
  duplicate: boolean;
  inboxEntryId: number;
  allowedStatusChanges: InboxEntryStatus[];
  allowClose: InboxEntryAlowClose;
};

export type EmailEntry = {
  id: number;
  inboxEntryId: number;
  from: UserWithFullNameAndEmailAndAvatar[];
  to: UserWithFullNameAndEmail[];
  cc: UserWithFullNameAndEmail[];
  files: EmailEntryFiles;
  emailType: EmailEntryType;
  status: InboxEntryStatus;
  subject: string;
  html: string;
  source: InboxEntrySource;
  dateAdded: string;
  openedDate: string;
  openedBy: string;
  closedDate: string;
  closedBy: string;
  modifiedDate: string;
  modifiedBy: string;
  workstreams: any[];
  tasks: any[];
  emailIdDetail: string;
  isRead: boolean;
  isDeleted: boolean;
  isMisc: boolean;
  duplicate: boolean;
  // accessList: any[];
  allowedStatusChanges: InboxEntryStatus[];
  allowClose: InboxEntryAlowClose;
  permissions: EmailEntryPermission;
  inboxEntry: RawInboxEntry;
  shouldWaitSocketUpdate?: boolean;
};

export type EmailEntrySummary = {
  id: number;
  emailId: number;
  subject: string;
  from: string | UserWithAvatar;
  raw: string;
  dateAdded: string;
  status: InboxEntryStatus;
  isRead: boolean;
  filesCount: number;
  openInboundAttachmentsCount: number;
  emailType: EmailEntryType;
};

export type EmailEntryToUpdateStatus = {
  id: number;
  inboxEntryId: number;
  status: InboxEntryStatus;
  duplicate: boolean;
  files: EmailFileEntry[];
  // user: UserWithFullNameAndEmail;
  allowedStatusChanges: InboxEntryStatus[];
  allowClose: InboxEntryAlowClose;
};

export type EmailThread = {
  emailEntries: any[];
};

export type EmailFileEntry = {
  emailId: number;
  date?: string;
  file: FileEntryToUpdateStatus;
};

export type EmailEntryToggleableListItem = {
  emailEntryListItem: EmailEntryListItem;
  isLatest?: boolean;
  isSelected?: boolean;
  isExpanded?: boolean;
  isVisible?: boolean;
};

export enum EmailThreadEntryViewerViews {
  EmailEntries = 'EmailEntries',
  Attachments = 'Attachments',
}

export type EmaiThreadEntryViewerPresets = {
  defaultView: EmailThreadEntryViewerViews;
  preselectedFile: InboxEntryFile;
};

export enum EmailDeliveryType {
  inbound = 'inbound',
  outbound = 'outbound',
}

// @TODO: map and use in react query calls
export type RawFileEntry = any;
export type RawEmailEntry = any;

export type SortOrder = 'asc' | 'desc';

export type UpdateFileEntryResponse =
  | {
      data: {
        'inbox-document': any;
        'inbox-entry': any;
      };
      status: boolean;
    }
  | ResponseError;
